"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TradingHero() {
  const headlineWords = [{
    text: "Where",
    italic: false
  }, {
    text: "global",
    italic: false
  }, {
    text: "markets",
    italic: false
  }, {
    text: "converge.",
    italic: true
  }];
  const {
    ref: labelRef,
    isVisible: labelVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.15
  });
  const {
    ref: introRef,
    isVisible: introVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.2
  });
  const {
    ref: image1Ref,
    isVisible: image1Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: image2Ref,
    isVisible: image2Visible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="2777" id="contacthero" className="bg-white text-slate-900 relative min-h-[85vh] w-full overflow-hidden py-20 md:py-28 lg:py-32">
      <div className="mx-auto max-w-[1440px] px-6 md:px-10 lg:px-16">
        {}
        <div ref={labelRef} className={`mb-12 md:mb-20 transition-all duration-700 ease-out ${labelVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <span className="font-sans text-xs md:text-sm uppercase tracking-[0.18em] text-blue-900">
            § kt-ex — global trade reimagined
          </span>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 relative">
          {}
          <div aria-hidden="true" className="hidden lg:block absolute top-0 bottom-0 left-[58.33%] w-px bg-slate-200" />

          {}
          <div className="lg:col-span-7 flex flex-col justify-center">
            <h1 ref={headlineRef} className="font-default font-bold leading-[0.92] tracking-tight text-slate-900" style={{
            fontSize: "clamp(56px, 12vw, 176px)"
          }}>
              {headlineWords.map((word, i) => <span key={i} data-index={i} className="inline-block overflow-hidden align-bottom mr-[0.18em]" style={{
              paddingBottom: "0.08em"
            }}>
                  <span className={`inline-block transition-all ease-out ${word.italic ? "italic" : ""} ${headlineVisible ? "translate-y-0 opacity-100" : "translate-y-full opacity-0"}`} style={{
                transitionDuration: "700ms",
                transitionDelay: `${i * 80}ms`,
                color: word.italic ? "#d4a574" : "inherit"
              }}>
                    {word.text}
                  </span>
                </span>)}
            </h1>

            <p ref={introRef} className={`font-default mt-10 md:mt-14 max-w-[36ch] text-base md:text-lg leading-relaxed transition-all duration-1000 delay-300 ease-out text-slate-700 ${introVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              Connecting buyers and suppliers through a seamless, transparent, and efficient digital trading ecosystem.
            </p>
          </div>

          {}
          <div className="lg:col-span-5 flex flex-col justify-center gap-8 lg:gap-10 lg:pl-6">
            {}
            <figure ref={image1Ref} className={`transition-all duration-1000 ease-out ${image1Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <div className="overflow-hidden rounded-xl bg-slate-100 shadow-md">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680628/img/global_trade_network.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680628/img/global_trade_network.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680628/img/global_trade_network.webp-wvc-sizes" alt="Digital visualization of global trade network connections" loading="lazy" decoding="async" className="w-full h-auto object-cover aspect-[4/5]" />
              </div>
              <figcaption className="mt-3 font-sans text-[11px] md:text-xs uppercase tracking-[0.16em] text-blue-900">
                plate i. / trade network
              </figcaption>
            </figure>

            {}
            <figure ref={image2Ref} className={`ml-auto w-[72%] transition-all duration-1000 delay-200 ease-out ${image2Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
              <div className="overflow-hidden rounded-xl bg-slate-100 shadow-md">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680628/img/logistics_optimization.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680628/img/logistics_optimization.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680628/img/logistics_optimization.png-wvc-sizes" alt="Logistics optimization dashboard interface" loading="lazy" decoding="async" className="w-full h-auto object-cover aspect-square" />
              </div>
              <figcaption className="mt-3 font-sans text-[11px] md:text-xs uppercase tracking-[0.16em] text-blue-900">
                plate ii. / logistics flow
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </section>;
}